/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetUniverseCategoriesCategoryIdOk
 */
export interface GetUniverseCategoriesCategoryIdOk {
    /**
     * category_id integer
     * @type {number}
     * @memberof GetUniverseCategoriesCategoryIdOk
     */
    categoryId: number;
    /**
     * groups array
     * @type {Array<number>}
     * @memberof GetUniverseCategoriesCategoryIdOk
     */
    groups: Array<number>;
    /**
     * name string
     * @type {string}
     * @memberof GetUniverseCategoriesCategoryIdOk
     */
    name: string;
    /**
     * published boolean
     * @type {boolean}
     * @memberof GetUniverseCategoriesCategoryIdOk
     */
    published: boolean;
}

/**
 * Check if a given object implements the GetUniverseCategoriesCategoryIdOk interface.
 */
export function instanceOfGetUniverseCategoriesCategoryIdOk(value: object): value is GetUniverseCategoriesCategoryIdOk {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    return true;
}

export function GetUniverseCategoriesCategoryIdOkFromJSON(json: any): GetUniverseCategoriesCategoryIdOk {
    return GetUniverseCategoriesCategoryIdOkFromJSONTyped(json, false);
}

export function GetUniverseCategoriesCategoryIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseCategoriesCategoryIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['category_id'],
        'groups': json['groups'],
        'name': json['name'],
        'published': json['published'],
    };
}

export function GetUniverseCategoriesCategoryIdOkToJSON(json: any): GetUniverseCategoriesCategoryIdOk {
    return GetUniverseCategoriesCategoryIdOkToJSONTyped(json, false);
}

export function GetUniverseCategoriesCategoryIdOkToJSONTyped(value?: GetUniverseCategoriesCategoryIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_id': value['categoryId'],
        'groups': value['groups'],
        'name': value['name'],
        'published': value['published'],
    };
}

